import type { QueryClient } from '@tanstack/react-query';
import { syncMySimpleInOutJobStatus } from '../../api/simpleInOut';

/**
 * After your own job clock action, ask the server to note (or clear) where you are on your Simple
 * In/Out status, then refresh the Home status card and header chip. It never blocks or fails the
 * clock action: the five-minute server sync retries anything this misses.
 */
export function syncSimpleInOutJobComment(queryClient: QueryClient): void {
  void syncMySimpleInOutJobStatus()
    .then(result => {
      if (result.applied || result.cleared) void queryClient.invalidateQueries({ queryKey: ['simple-inout', 'me', 'status'] });
    })
    .catch((error: unknown) => {
      console.warn('Simple In/Out job comment sync failed; the server retries within five minutes.', error);
    });
}
